import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPassport: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconPassport"><Path d="M10.5 10.5C10.5 9.67157 11.1716 9 12 9C12.8284 9 13.5 9.67157 13.5 10.5C13.5 11.3284 12.8284 12 12 12C11.1716 12 10.5 11.3284 10.5 10.5Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M3.5 2.5V21.5H20.5V2.5H3.5ZM8.5 15H15.5V17H8.5V15ZM12 7C10.067 7 8.5 8.567 8.5 10.5C8.5 12.433 10.067 14 12 14C13.933 14 15.5 12.433 15.5 10.5C15.5 8.567 13.933 7 12 7Z" fill="currentColor"/></CentralIconBase>;
});

export default IconPassport;
